/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Setapikey2Inputs */

const id_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silakan atur kunci API Anda untuk mengaktifkan notifikasi push.`)
};

const ms_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sila tetapkan kunci API anda untuk membolehkan pemberitahuan push.`)
};

const da_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indstil venligst din API-nøgle for at aktivere push-notifikationer.`)
};

const de_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte legen Sie Ihren API-Schlüssel fest, um Push-Benachrichtigungen zu aktivieren.`)
};

const en_us2_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please set your API key to enable push notifications.`)
};

const es_es2_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, configura tu API key para habilitar las notificaciones push.`)
};

const es_mx2_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, configura tu API key para habilitar las notificaciones push.`)
};

const fil_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mangyaring itakda ang iyong API key upang i-enable ang push notifications.`)
};

const fr_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez définir votre clé API pour activer les notifications push.`)
};

const it_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta la tua chiave API per abilitare le notifiche push.`)
};

const hu_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kérjük, állítsd be az API kulcsodat a push értesítések engedélyezéséhez.`)
};

const nl_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stel je API-sleutel in om pushmeldingen in te schakelen.`)
};

const no_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vennligst angi API-nøkkelen din for å aktivere push-varsler.`)
};

const pl_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proszę ustawić klucz API, aby włączyć powiadomienia push.`)
};

const pt_br2_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please set your API key to enable push notifications.`)
};

const pt_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, defina a sua chave de API para ativar notificações push.`)
};

const ro_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te rugăm să setezi cheia API pentru a activa notificările push.`)
};

const fi_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aseta API-avain ottaaksesi push-ilmoitukset käyttöön.`)
};

const sv_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vänligen ange din API-nyckel för att aktivera push-notiser.`)
};

const vi_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng đặt khóa API của bạn để bật thông báo đẩy.`)
};

const tr_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push bildirimlerini etkinleştirmek için lütfen API anahtarınızı ayarlayın.`)
};

const cs_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro povolení push oznámení nastavte svůj API klíč.`)
};

const bg_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Моля, задайте своя API ключ, за да активирате push известията.`)
};

const ru_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, установите ваш API-ключ для включения push-уведомлений.`)
};

const uk_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будь ласка, встановіть ваш API-ключ, щоб увімкнути push-сповіщення.`)
};

const ar_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يرجى تعيين مفتاح API الخاص بك لتمكين الإشعارات الفورية.`)
};

const hi_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया अपनी API कुंजी सेट करें।`)
};

const th_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปรดตั้งค่าคีย์ API ของคุณเพื่อเปิดใช้งานการแจ้งเตือนแบบพุช`)
};

const ja_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プッシュ通知を有効にするには API キーを設定してください。`)
};

const zh_cn2_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please set your API key to enable push notifications.`)
};

const zh_hant1_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please set your API key to enable push notifications.`)
};

const ko_notifications_push_setapikey2 = /** @type {(inputs: Notifications_Push_Setapikey2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`푸시 알림을 활성화하려면 API 키를 설정하세요.`)
};

/**
* | output |
* | --- |
* | "Please set your API key to enable push notifications." |
*
* @param {Notifications_Push_Setapikey2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_setapikey2 = /** @type {((inputs?: Notifications_Push_Setapikey2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Setapikey2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_setapikey2(inputs)
	if (locale === "ms") return ms_notifications_push_setapikey2(inputs)
	if (locale === "da") return da_notifications_push_setapikey2(inputs)
	if (locale === "de") return de_notifications_push_setapikey2(inputs)
	if (locale === "en-US") return en_us2_notifications_push_setapikey2(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_setapikey2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_setapikey2(inputs)
	if (locale === "fil") return fil_notifications_push_setapikey2(inputs)
	if (locale === "fr") return fr_notifications_push_setapikey2(inputs)
	if (locale === "it") return it_notifications_push_setapikey2(inputs)
	if (locale === "hu") return hu_notifications_push_setapikey2(inputs)
	if (locale === "nl") return nl_notifications_push_setapikey2(inputs)
	if (locale === "no") return no_notifications_push_setapikey2(inputs)
	if (locale === "pl") return pl_notifications_push_setapikey2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_setapikey2(inputs)
	if (locale === "pt") return pt_notifications_push_setapikey2(inputs)
	if (locale === "ro") return ro_notifications_push_setapikey2(inputs)
	if (locale === "fi") return fi_notifications_push_setapikey2(inputs)
	if (locale === "sv") return sv_notifications_push_setapikey2(inputs)
	if (locale === "vi") return vi_notifications_push_setapikey2(inputs)
	if (locale === "tr") return tr_notifications_push_setapikey2(inputs)
	if (locale === "cs") return cs_notifications_push_setapikey2(inputs)
	if (locale === "bg") return bg_notifications_push_setapikey2(inputs)
	if (locale === "ru") return ru_notifications_push_setapikey2(inputs)
	if (locale === "uk") return uk_notifications_push_setapikey2(inputs)
	if (locale === "ar") return ar_notifications_push_setapikey2(inputs)
	if (locale === "hi") return hi_notifications_push_setapikey2(inputs)
	if (locale === "th") return th_notifications_push_setapikey2(inputs)
	if (locale === "ja") return ja_notifications_push_setapikey2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_setapikey2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_setapikey2(inputs)
	return ko_notifications_push_setapikey2(inputs)
});
export { notifications_push_setapikey2 as "notifications.push.setApiKey" }